import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { useParams } from "react-router-dom";
import {
  Button,
  DatePicker,
  Dropdown,
  Modal,
  Tabs,
  message,
  Switch,
} from "antd";
import dayjs from "dayjs";
import { DoubleLeftOutlined } from "@ant-design/icons";
import withDashboardLayout from "../../../hoc/withDashboardLayout";
import Services from "../../../components/admin/serviceProviderDetails/Services";
import Gallery from "../../../components/admin/serviceProviderDetails/Gallery";
import Reviews from "../../../components/admin/serviceProviderDetails/Reviews";
import StarIcon from "../../../assets/star-icon.png";
import LocationIcon from "../../../assets/location-icon.png";
// import GlobeIcon from "../../../assets/globe-icon.png";
import MailIcon from "../../../assets/mail-icon.png";
import SendIcon from "../../../assets/send-icon.png";
import ThreeDotsIcon from "../../../assets/threedots-icon.png";
import {
  DeleteServiceProvider,
  GetServiceProviderById,
  GetServiceProviderDashboardData,
  GetServiceProviderRating,
  ToggleAvailability,
  UpdateServiceProvider,
} from "../../../utils/api";
import Loader from "../../../components/shared/Loader";
import SendEmailNotification from "../../../components/admin/serviceProvider/SendEmailNotification";
import StarRound from "../../../assets/star-round.svg";
import { imgPath } from "../../../utils/axiosInstance";
import Availability from "../../../components/admin/serviceProviderDetails/Availability";
import Bookings from "../../../components/admin/serviceProviderDetails/Bookings";
import Prefrences from "../../../components/admin/serviceProviderDetails/Prefrences";
import Promocodes from "../../../components/admin/serviceProviderDetails/Promocodes";
import { convertToViewableAmount } from "../../../utils/helper";

const dropdownItems = [
  {
    label: "Remove from Spotlight",
    key: 0,
  },
  {
    label: "Add to Spotlight",
    key: 2,
  },
  {
    label: "Delete",
    key: "deleted",
  },
];

const ServiceProviderDetails = () => {
  const { state } = useLocation();
  const { RangePicker } = DatePicker;
  const { id } = useParams();
  const navigate = useNavigate();
  const [notificationDrawerData, setNotificationDrawerData] = useState({
    visible: false,
    data: null,
  });
  const [loading, setLoading] = useState(true);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [serviceData, setServiceData] = useState(null);
  const [spDashboardData, setSPDashboardData] = useState(null);
  const [averageRating, setAverageRating] = useState(null);
  const [activeTab, setActiveTab] = useState("availability");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [modalData, setModalData] = useState({
    visible: false,
    action: null,
    value: null,
    data: null,
  });

  const onRangeChange = (dates) => {
    if (dates === null) {
      setEndDate(null);
      setStartDate(null);
    }
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("YYYY-MM-DD");
      const endDate = dates[1].format("YYYY-MM-DD");
      if (startDate) {
        setStartDate(startDate);
      }
      if (endDate) {
        setEndDate(endDate);
      }
    }
  };

  const items = [
    {
      key: "services",
      label: `Services`,
      children: <Services startDate={startDate} endDate={endDate} />,
    },
    {
      key: "gallery",
      label: `Gallery`,
      children: (
        <Gallery
          activeTab={activeTab}
          startDate={startDate}
          endDate={endDate}
        />
      ),
    },
  ];

  if (state?.type === "onboarded") {
    items.unshift({
      key: "availability",
      label: `Availability`,
      children: <Availability serviceData={serviceData} />,
    });
  }

  if (state?.type === "onboarded") {
    items.push({
      key: "reviews",
      label: `Reviews`,
      children: (
        <Reviews
          id={id}
          startDate={startDate}
          endDate={endDate}
          activeTab={activeTab}
        />
      ),
    });
  }

  if (state?.type === "onboarded") {
    items.push({
      key: "bookings",
      label: `Bookings`,
      children: <Bookings />,
    });
  }

  if (state?.type === "onboarded") {
    items.push({
      key: "promocodes",
      label: `Promo Codes`,
      children: <Promocodes />,
    });
  }

  if (state?.type === "onboarded") {
    items.push({
      key: "prefrences",
      label: `Preferences`,
      children: <Prefrences />,
    });
  }

  const onTabChange = (key) => {
    setActiveTab(key);
    setStartDate(null);
    setEndDate(null);
  };

  const handleBack = () => {
    navigate("/admin/service-providers");
  };

  const getServiceById = async () => {
    setLoading(true);
    try {
      const res = await GetServiceProviderById(id);
      if (res?.isSuccess) {
        setServiceData(res?.data);
        getServiceDashboardData(res?.data?.user_id);
        setLoading(false);
      } else {
        setLoading(false);
        message.error("Error while fetching details, Please try again");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const onToggleAvailability = async (value) => {
    try {
      setToggleLoading(true);
      const res = await ToggleAvailability({
        type: value ? "on" : "off",
        userId: serviceData?.user?.id,
      });
      if (res?.isSuccess) {
        message.success("Availability status updated successfully.");
        getServiceById();
        setToggleLoading(false);
      } else {
        setToggleLoading(false);
        message.error(
          res?.error || "Error while changing availability, Please try again"
        );
      }
    } catch (error) {
      setToggleLoading(false);
    }
  };

  const getServiceDashboardData = async (userid) => {
    if (userid) {
      try {
        const query = {
          userId: userid,
          businessId: id,
        };
        if (startDate) {
          query.startDate = startDate;
        }
        //  else {
        //   query.startDate = "";
        // }
        if (endDate) {
          query.endDate = endDate;
        }
        //  else {
        //   query.endDate = "";
        // }
        setLoading(true);
        const response = await GetServiceProviderDashboardData(query);
        setSPDashboardData(response?.data);
        setLoading(false);
      } catch (error) {
        message.error("Error while fetching details, Please try again");
        setLoading(false);
      }
    }
  };

  const getAverageRating = async () => {
    setLoading(true);
    if (id) {
      try {
        const res = await GetServiceProviderRating({ businessProfileId: id });
        if (res?.isSuccess) {
          setAverageRating(res?.message);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      setLoading(true);
      message.error("Error while fetching details, Please try again");
    }
  };

  const handleActionModalOpen = (value, data) => {
    setModalData({
      visible: true,
      action: value === "deleted" ? "delete" : "spotlight",
      value: value,
      data: data,
    });
  };

  const handleOk = async () => {
    if (modalData.action === "delete") {
      try {
        setBtnLoading(true);
        const res = await DeleteServiceProvider(
          { statusType: modalData?.value },
          id
        );
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Service provider deleted successfully");
          setModalData({
            id: null,
            visible: false,
            selectedStatus: null,
            user: null,
            action: null,
          });
          navigate(-1);
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in deletion, Try again later");
      }
    } else if (modalData.action === "spotlight") {
      try {
        setBtnLoading(true);
        const res = await UpdateServiceProvider(
          { is_featured: modalData?.value },
          id
        );
        setBtnLoading(false);
        if (res?.isSuccess) {
          message.success("Service provider spotlight status successfully");
          setModalData({
            id: null,
            visible: false,
            selectedStatus: null,
            user: null,
            action: null,
          });
          getServiceById();
        }
      } catch (error) {
        setBtnLoading(false);
        message.error("Error in Updation, Try again later");
      }
    }
  };

  const handleModalCancel = () => {
    setModalData({ visible: false, action: null, value: null, data: null });
  };

  useEffect(() => {
    if (id) {
      getServiceById();
      getAverageRating();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getServiceDashboardData(serviceData?.user_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Service Provider Details Header */}
        <div className="w-full py-4 gap-x-2 flex items-center back-icon">
          <h1 className="font-semibold text-lg cursor-pointer">
            Service Providers
          </h1>
          <DoubleLeftOutlined onClick={handleBack} />
          <h1 className="font-semibold text-lg text-black-300">
            Service Provider Details
          </h1>
        </div>

        {/* Service Provider Details */}
        <div className="w-full bg-white min-h-[calc(100vh-110px)] flex flex-col gap-y-4 box-shadow rounded-t-2xl pt-5">
          <div className="border border-[#3761971A] rounded-lg mx-6 p-5 flex justify-between gap-x-8">
            {/* Info */}
            <div className="w-2.5/12">
              <div className="details">
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <img
                      src={`${imgPath}${serviceData?.image}`}
                      alt={serviceData?.business_name}
                      className="w-12 h-12 object-cover rounded-lg"
                    />
                    {serviceData?.isFeatured === 2 ? (
                      <img
                        className="absolute -bottom-1 -right-1.5 w-4"
                        src={StarRound}
                        alt="star-round"
                      />
                    ) : null}
                  </div>
                  <div className="">
                    <p className="text-sm font-medium leading-none text-[#24242E]">
                      {serviceData?.business_name}
                    </p>
                    <span className="text-xs leading-none text-[#12B500]">
                      {serviceData?.user_name}
                    </span>
                    <div className="flex items-center gap-x-1">
                      <img src={StarIcon} alt="star-icon" className="w-4 h-4" />
                      <span className="text-xs leading-none pt-[1px] font-medium text-primary-900">
                        {averageRating || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-lightGray text-xs pt-2 flex flex-col gap-1">
                <div className="flex items-center gap-x-2">
                  <img
                    src={LocationIcon}
                    alt="location-icon"
                    className="mt-0.5 w-3 h-3"
                  />
                  <span className="overflow-x-clip break-words">
                    {serviceData?.business_location}
                  </span>
                </div>
                {/* <div className="flex items-center gap-x-2">
                  <img
                    src={GlobeIcon}
                    alt="location-icon"
                    className="w-3 h-3"
                  />
                  <span>{serviceData?.booking_link}</span>
                </div> */}
                <div className="flex items-start gap-x-2">
                  <img
                    src={MailIcon}
                    alt="mail-icon"
                    className="mt-0.5 w-3 h-3"
                  />
                  <span className="">{serviceData?.user?.email}</span>
                </div>
              </div>
            </div>

            {/* Card Widgets */}
            {state?.type === "onboarded" && (
              <div className="w-7/12 bg-[#f5f2f3] pl-1 pr-5 py-8 border border-primary-700 rounded-xl flex items-center justify-center">
                {/* <div className="flex-1 text-center border-r border-primary-700 flex flex-col gap-y-2">
                <div className="flex items-center justify-center gap-x-1">
                  <span className="text-2xl font-bold text-primary-900">
                    {averageRating || 0}
                  </span>
                  <img src={StarIcon} alt="star-icon" className="w-4 h-4" />
                </div>
                <span className="text-xs text-primary-900 font-medium">
                  Rating
                </span>
              </div> */}
                {/* Wallet */}
                <div className="flex-1 text-center border-r border-primary-700 flex flex-col gap-y-2">
                  <span className="text-xl font-bold text-primary-900">
                    {convertToViewableAmount(spDashboardData?.wallet)}
                  </span>
                  <span className="text-xs text-primary-900 font-medium">
                    Wallet
                  </span>
                </div>
                {/* Total Revenue */}
                <div className="flex-1 text-center border-r border-primary-700 flex flex-col gap-y-2">
                  <span className="text-xl font-bold text-primary-900">
                    {convertToViewableAmount(spDashboardData?.totalRevenue)}
                  </span>
                  <span className="text-xs text-primary-900 font-medium">
                    Total Revenue
                  </span>
                </div>
                {/* Avg Revenue */}
                <div className="flex-1 text-center border-r border-primary-700 flex flex-col gap-y-2">
                  <span className="text-xl font-bold text-primary-900">
                    {convertToViewableAmount(spDashboardData?.averageRevenue)}
                  </span>
                  <span className="text-xs text-primary-900 font-medium">
                    Avg. Revenue
                  </span>
                </div>
                {/* BNC */}
                {/* <div className="flex-1 text-center border-r border-primary-700 px-2 flex flex-col gap-y-2">
                  <span className="text-2xl font-bold text-primary-900">
                    {spDashboardData?.bookings}
                  </span>
                  <span className="text-xs text-primary-900 font-medium">
                    Bookings
                  </span>
                </div> */}
                {/* Profile Views */}
                <div className="flex-1 text-center border-r border-primary-700 flex flex-col gap-y-2">
                  <span className="text-xl font-bold text-primary-900">
                    {spDashboardData?.profileViews}
                  </span>
                  <span className="text-xs text-primary-900 font-medium">
                    Profile Views
                  </span>
                </div>
                {/* Conversion Rate */}
                <div className="flex-1 text-center flex flex-col gap-y-2">
                  <span className="text-xl font-bold text-primary-900">
                    {spDashboardData?.conversionRate}%
                  </span>
                  <span className="text-xs text-primary-900 font-medium">
                    Conversion Rate
                  </span>
                </div>
              </div>
            )}

            {/* Actions */}
            <div className="w-2.5/12 flex flex-col items-end justify-between">
              <div className="flex gap-x-2 items-center justify-between">
                {/* Toggle Switch */}
                {activeTab === "availability" &&
                  state?.type === "onboarded" && (
                    <Switch
                      loading={toggleLoading}
                      checked={serviceData?.user?.isAvailable}
                      onChange={onToggleAvailability}
                    />
                  )}
                <div
                  className={`bg-primary-300 
                                ${
                                  serviceData?.statusType === "active" &&
                                  state.type === "requested"
                                    ? "text-[red]"
                                    : serviceData?.statusType === "active"
                                    ? "text-[#54a43a]"
                                    : serviceData?.statusType === "inactive"
                                    ? "text-orange"
                                    : serviceData?.statusType === "blocked"
                                    ? "text-[red]"
                                    : ""
                                } border flex items-center gap-x-1 py-1 px-2.5 text-sm rounded-md font-medium`}
                >
                  <span className={`capitalize`}>
                    {state?.type === "requested"
                      ? "Requested"
                      : serviceData?.statusType}
                  </span>
                </div>
                <button
                  className="w-5 h-5 flex-shrink-0 cursor-pointer"
                  onClick={() =>
                    setNotificationDrawerData({
                      visible: true,
                      data: serviceData,
                    })
                  }
                >
                  <img src={SendIcon} alt="send-icon" />
                </button>
                {state?.type === "onboarded" && (
                  <button className="w-5 h-5 flex-shrink-0">
                    <Dropdown
                      menu={{
                        items: dropdownItems.filter(
                          (item) => item.key !== serviceData?.isFeatured
                        ),
                        onClick: (e) =>
                          handleActionModalOpen(e?.key, serviceData),
                      }}
                      trigger={["click"]}
                    >
                      <img src={ThreeDotsIcon} alt="send-icon" />
                    </Dropdown>
                  </button>
                )}
              </div>
              {(activeTab === "availability" ||
                activeTab === "gallery" ||
                activeTab === "reviews") &&
                state?.type === "onboarded" && (
                  <div className="flex items-center flex-col gap-y-2">
                    <span className="text-sm text-primary-900 font-medium">
                      Select Range
                    </span>
                    <RangePicker
                      value={[
                        startDate ? dayjs(startDate) : null,
                        endDate ? dayjs(endDate) : null,
                      ]}
                      onChange={onRangeChange}
                      format="D MMM YY"
                      disabledDate={(current) =>
                        current && current > dayjs().endOf("day")
                      }
                      // presets={rangePresets}
                    />
                  </div>
                )}
            </div>
          </div>

          <SendEmailNotification
            notificationDrawerData={notificationDrawerData}
            setNotificationDrawerData={setNotificationDrawerData}
            type="details"
          />

          {/* Tabs */}
          <div className="w-full">
            <Tabs
              defaultActiveKey={activeTab}
              items={items}
              onChange={onTabChange}
            />
          </div>

          <Modal
            centered
            title={
              modalData.action === "spotlight"
                ? "Confirm Spotlight Status Change"
                : "Confirm Delete"
            }
            open={modalData.visible}
            onCancel={handleModalCancel}
            footer={
              <div>
                <Button onClick={handleModalCancel}>Cancel</Button>
                <Button
                  type="primary"
                  className="text-white"
                  onClick={handleOk}
                >
                  Ok
                  {btnLoading && (
                    <span className="loader ml-2 align-middle mb-1"></span>
                  )}
                </Button>
              </div>
            }
          >
            {modalData.action === "spotlight"
              ? `Are you sure you want to change spotlight status of ${modalData.data?.business_name}?`
              : `Are you sure you want to delete ${modalData.data?.business_name}?`}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default withDashboardLayout(ServiceProviderDetails);
